module.exports = __webpack_public_path__ + "img/6.1e0740c2.png";